var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcQuytac(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0715 2.92878C13.1663 -0.976043 6.83448 -0.976478 2.92878 2.92878C-0.976478 6.83404 -0.976043 13.1658 2.92878 17.0715C6.83404 20.9759 13.1658 20.9764 17.0715 17.0715C20.9764 13.1658 20.9759 6.83448 17.0715 2.92878ZM11.3041 14.348C11.3041 15.0685 10.7202 15.6524 9.99973 15.6524C9.27929 15.6524 8.69537 15.0685 8.69537 14.348V9.13059C8.69537 8.41015 9.27929 7.82623 9.99973 7.82623C10.7202 7.82623 11.3041 8.41015 11.3041 9.13059V14.348ZM9.97668 6.901C9.22537 6.901 8.7245 6.36882 8.74015 5.71186C8.7245 5.02315 9.22537 4.50706 9.9919 4.50706C10.7589 4.50706 11.2441 5.02359 11.2602 5.71186C11.2597 6.36882 10.7593 6.901 9.97668 6.901Z",
    fill: "#009B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuytac);
export default __webpack_public_path__ + "static/media/ic-quytac.90b504d0792a9a9c5f849612017d6dc8.svg";
export { ForwardRef as ReactComponent };